<template>
  <div class="add-record">
    <div class="title flex-between">
      <h3>添加跟单记录</h3>
      <span @click="backLink" class="flex-center"> <van-icon name="arrow-left" /> 返回 </span>
    </div>
    <van-form @submit="onSubmit">
      <div class="f-required">
        <van-field
          readonly
          required
          clickable
          :value="typeName"
          name="type"
          label="学员类型："
          placeholder="请选择"
          @click="showPicker = true"
          :rules="[{ required: true, message: '请选择学员类型', trigger: 'blur' }]"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker show-toolbar :columns="columnsType" value-key="dname" @confirm="onConfirmStudentType" @cancel="showPicker = false" />
        </van-popup>
      </div>
      <div class="f-required">
        <!-- <b class="second-icon">❊</b> -->
        <van-field
          v-model="filter.remark"
          required
          maxlength="300"
          show-word-limit
          rows="5"
          name="remark"
          label="跟单内容："
          placeholder="请填写跟单内容(不支持表情包)"
          type="textarea"
          :rules="[{ required: true, message: '请填写跟单内容' }]"
        />
      </div>
      <div class="f-required">
        <van-field
          readonly
          required
          clickable
          :value="onelevelName"
          name="type"
          label="一级分类："
          placeholder="请选择"
          @click="showPickerFirstLevel = true"
          :rules="[{ required: true, message: '请选择一级分类', trigger: 'blur' }]"
        />
        <van-popup v-model="showPickerFirstLevel" position="bottom">
          <van-picker show-toolbar :columns="oneColumn" value-key="typeName" @confirm="onConfirmFirstLevel" @cancel="showPickerFirstLevel = false" />
        </van-popup>
      </div>
      <div class="f-required">
        <van-field readonly clickable :value="twolevelName" name="type" label="二级分类：" placeholder="请选择" @click="showPickerSecondLevel = true" />
        <van-popup v-model="showPickerSecondLevel" position="bottom">
          <van-picker show-toolbar :columns="twoColumn" value-key="typeName" @confirm="onConfirmSecondLevel" @cancel="showPickerSecondLevel = false" />
        </van-popup>
      </div>
      <div class="f-required">
        <van-field readonly clickable :value="thrlevelName" name="type" label="三级分类：" placeholder="请选择" @click="showPickerThirdLevel = true" />
        <van-popup v-model="showPickerThirdLevel" position="bottom">
          <van-picker show-toolbar :columns="thirColumn" value-key="typeName" @confirm="onConfirmThirdLevel" @cancel="showPickerThirdLevel = false" />
        </van-popup>
      </div>
      <van-field readonly clickable name="nexttracetime" :value="filter.createtime" label="下次跟单时间：" placeholder="点击选择日期" @click="nextCalendar = true" />
      <!--  -->
      <van-calendar v-model="nextCalendar" @confirm="nextonConfirm" color="#277FFF" />
      <van-field readonly clickable name="planstudytime" :value="filter.planstudytime" label="预计学习时间：" placeholder="点击选择日期" @click="planCalendar = true" />
      <!--  -->
      <van-calendar v-model="planCalendar" @confirm="dateonConfirm" color="#277FFF" />
      <div class="submit-btn">
        <van-button block type="info" native-type="submit">确定</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import addRecord from "@/views/studentInfo/js/addRecord";
export default addRecord;
</script>
<style scoped lang="less">
@import "css/addRecord";
</style>
